import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { apiClient } from "@/api/endpoints";
import { useAuth } from "@/features/auth";

export const Route = createFileRoute("/_public/auth/logout")({
  beforeLoad: async () => {
    await apiClient.auth.signOut();
  },
  component: RouteComponent,
});

function RouteComponent() {
  const router = useRouter();
  const { resetAccount } = useAuth();

  useEffect(() => {
    resetAccount();
    router.navigate({ to: "/" });
  }, [resetAccount, router]);

  return null;
}
